// TODO: reinstate translation fetching
// import axios from 'axios'

// export default async function ({ $config, route }) {
//   const apiClient = axios.create({
//     baseURL: process.browser ? $config.axios.publicBrowserBaseURL : $config.axios.publicBaseURL
//   })

//   const { data } = await apiClient.get('i18n/get/en/', { params: { review: 'i18n' in route.query } })
//   return data
// }

export default function () {
  return {}
}